import { useSearchParams } from 'react-router-dom';
import { EQUIPMENT_IMAGE_TYPE, LAYOUT_IMAGE_TYPE } from 'utils/attachments';
import {
  existingEquipmentUploadContent,
  structureLayoutUploadContent
} from './public-image-upload-content';
import PublicImageUploadPage from './public-image-upload-page';

export default function PublicImagesPage() {
  const [searchParams] = useSearchParams();
  const structureUniqueId = searchParams.get('sid');
  const imageType =
    searchParams.get('type') === EQUIPMENT_IMAGE_TYPE
      ? EQUIPMENT_IMAGE_TYPE
      : LAYOUT_IMAGE_TYPE;
  const content =
    imageType === EQUIPMENT_IMAGE_TYPE
      ? existingEquipmentUploadContent
      : structureLayoutUploadContent;

  return (
    <PublicImageUploadPage
      structureUniqueId={structureUniqueId}
      imageType={imageType}
      {...content}
    />
  );
}
